import { Pressable, View } from 'react-native'
import { styled } from '~/core/styled'

export const Root = styled(Pressable, theme => {
  return {
    base: {
      minWidth: theme.sizingMediumlarge,

      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',

      borderRadius: theme.borderRadiusPill,
      borderWidth: theme.borderWidthQuarterpulse,
      borderColor: theme.colorActionBorderNeutralSecondaryEnabled,

      paddingRight: theme.paddingInsetFourpulse,
      paddingLeft: theme.paddingInsetFourpulse,
    },

    variants: {
      size: {
        md: {
          height: theme.sizingMedium,
        },
        ml: {
          height: theme.sizingMediumlarge,
          minWidth: theme.sizingMediumlarge,
        },
      },
      selected: {
        true: {
          borderColor: theme.colorActionBorderNeutralSecondaryActivated, //cor do token não corresponde com o figma.
          borderWidth: theme.borderWidthHalfpulse,
          gap: theme.paddingInsetTwopulse,
          backgroundColor: theme.colorActionFillNeutralSecondaryActivated,
        },
      },
      checked: {
        true: {
          paddingLeft: theme.paddingInsetTwopulse,
          paddingRight: theme.paddingInsetFourpulse,
          gap: theme.paddingInsetTwopulse,
          borderColor: theme.colorActionBorderNeutralSecondaryActivated, //cor do token não corresponde com o figma.
          backgroundColor: theme.colorActionFillNeutralSecondaryActivated,
          borderWidth: theme.borderWidthQuarterpulse,
        },
      },
      readOnly: {
        true: {
          borderColor: theme.colorActionBorderNeutralSecondaryDisabled,
          borderWidth: theme.borderWidthQuarterpulse,
          backgroundColor: theme.colorActionFillNeutralSecondaryDisabled,
        },
      },
      disabled: {
        true: {
          borderColor: theme.colorActionBorderNeutralSecondaryDisabled,
          borderWidth: theme.borderWidthQuarterpulse,
          color: theme.colorTextNeutralDisabled,
          backgroundColor: theme.colorActionFillNeutralSecondaryDisabled,
        },
      },
    },
    compoundVariants: [
      {
        variants: {
          selected: true,
          isPressed: true,
          readOnly: false,
        },
        css: {
          backgroundColor: theme.colorActionFillNeutralSecondaryPressed,
          borderWidth: theme.borderWidthQuarterpulse,
          borderColor: theme.colorActionBorderNeutralSecondaryPressed,
        },
      },
      {
        variants: {
          selected: false,
          isPressed: true,
          readOnly: false,
        },
        css: {
          backgroundColor: theme.colorActionFillNeutralSecondaryPressed,
          borderColor: theme.colorActionBorderNeutralSecondaryPressed,
        },
      },
      {
        variants: {
          selected: true,
          checked: true,
          size: 'md',
          disabled: true,
        },
        css: {
          borderWidth: theme.borderWidthQuarterpulse,
          backgroundColor: theme.colorActionFillNeutralSecondaryDisabled,
          borderColor: theme.colorActionBorderNeutralSecondaryDisabled,
        },
      },
      {
        variants: {
          selected: true,
          checked: false,
          size: 'md',
          disabled: true,
        },
        css: {
          borderWidth: theme.borderWidthQuarterpulse,
          backgroundColor: theme.colorActionFillNeutralSecondaryDisabled,
          borderColor: theme.colorActionBorderNeutralSecondaryDisabled,
        },
      },
      {
        variants: {
          selected: false,
          checked: true,
          size: 'md',
          disabled: true,
        },
        css: {
          borderWidth: theme.borderWidthQuarterpulse,
          backgroundColor: theme.colorActionFillNeutralSecondaryDisabled,
          borderColor: theme.colorActionBorderNeutralSecondaryDisabled,
        },
      },
    ],
  }
})

export const LabelContainer = styled(View, {
  base: {
    flexShrink: 1,
  },
})
